export default __webpack_public_path__ + "static/media/logo_delta_colorida.7df28169.png";